import { render, staticRenderFns } from "./Chevron.vue?vue&type=template&id=4df533fa&scoped=true&"
import script from "./Chevron.vue?vue&type=script&lang=js&"
export * from "./Chevron.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df533fa",
  null
  
)

export default component.exports